import React from 'react';
import { DataTypes } from 'components/CleanRooms/AllQuestions/DataTypes';
import {
  QuestionTypeCell,
  TagsCell,
} from 'components/CleanRooms/CurrentQuestions/QuestionsTableLayout/TableCellComponents';
import { cellTypesEnum } from 'BaseComponents';


export const getColumns = () => [{
  field: 'displayID',
  name: 'Display Id',
  width: 100,
},
{
  field: 'Name',
  name: 'Name',
  width: 350,
  type: cellTypesEnum.LINE_3,
  valueGetter: ({ row }) => (row.title),
}, {
  field: 'isUserListQuestion',
  name: 'Type',
  width: 70,
  component: QuestionTypeCell,
}, {
  field: 'Required Datasets',
  name: 'Required Datasets',
  width: 180,
  component: ({ row }) => <DataTypes details={row} />,
}, {
  field: 'Category',
  name: 'Category',
  width: 140,
  valueGetter: ({ row }) => (row.category),
}, {
  field: 'tags',
  name: 'Tags',
  width: 70,
  component: TagsCell,
}, {
  field: 'Created On',
  name: 'Date Created',
  width: 120,
  type: cellTypesEnum.US_DATE_FORMAT,
  valueGetter: ({ row }) => (row.timeAudit.createdAt),
}, {
  field: 'Last Modified Date',
  name: 'Date Modified',
  width: 225,
  type: cellTypesEnum.US_DATE_FORMAT,
  valueGetter: ({ row }) => (row.timeAudit.updatedAt),
}].filter(Boolean);
